import React from "react";
import { Button } from "antd";
import useDeleteAbnormalCause from "@/scenes/OrderManagement/hooks/useDeleteAbnormalCause";
import OrderDTO from "@/dto/order/OrderDTO";
import { observer } from "mobx-react-lite";
import OrderTab from "../../enum/OrderTab";

interface DeleteAbnormalOrderButtonProps {
    getSelectedOrders(): OrderDTO[];
    tab: OrderTab;
}

const DeleteAbnormalOrderButton: React.FC<DeleteAbnormalOrderButtonProps> = ({ getSelectedOrders, tab }) => {
    const { handleDeleteAbnormalCause, deleting } = useDeleteAbnormalCause(tab);

    const handleDeleteAbnormalCauseClick = () => {
        const orders = getSelectedOrders();

        handleDeleteAbnormalCause(orders);
    };

    return (
        <Button loading={deleting} type="primary" danger onClick={handleDeleteAbnormalCauseClick} className="mr3">
            删除异常
        </Button>
    );
};

export default observer(DeleteAbnormalOrderButton);
